import React from 'react'

export default function Game() {
  return (
    <div className="screen-game">
      <h1>Settings</h1>
      <div style={{backgroundPosition : 'center', backgroundSize : 'cover'}}>
          <img src="./img/settings.jpg" alt="..." />          
      </div>
    </div>
  )
}
